'use client';

import { motion } from 'framer-motion';

export default function Transition({
  children,
  className,
  horizontal = false,
  skipAnimation = false,
}: {
  children: React.ReactNode;
  className?: string;
  horizontal?: boolean;
  skipAnimation?: boolean;
}) {
  return (
    <motion.div
      initial={
        skipAnimation
          ? {}
          : horizontal
            ? { x: 20, opacity: 0 }
            : { y: 20, opacity: 0 }
      }
      animate={
        skipAnimation
          ? {}
          : horizontal
            ? { x: 0, opacity: 1 }
            : { y: 0, opacity: 1 }
      }
      transition={
        skipAnimation ? { duration: 0 } : { ease: 'easeInOut', duration: 0.4 }
      }
      className={className}
      id='transition-container'
    >
      {children}
    </motion.div>
  );
}
